import { render } from "./PendaftaranView.vue?vue&type=template&id=4610d6c6"
import script from "./PendaftaranView.vue?vue&type=script&lang=js"
export * from "./PendaftaranView.vue?vue&type=script&lang=js"

import "./PendaftaranView.vue?vue&type=style&index=0&id=4610d6c6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__